import React from 'react';

// components
import { Select } from '../components/inputs';
import { FormRow } from '../components/layout';

function Language() {
  return (
    <div>
      <FormRow>
        <Select
          name="spokenlang"
          cols="8"
        />
      </FormRow>
      <FormRow>
        <Select
          name="preflang"
          cols="8"
        />
      </FormRow>
      <FormRow>
        <Select
          label="Alternative accessible formats for written documents"
          name="altwritten"
          cols="8"
        />
      </FormRow>
    </div>
  );
}

export default Language;
